import './Main.css'

import React, { useEffect, useMemo, useRef, useState } from 'react'
import DatePicker from 'react-datepicker'
import { useWizard } from '@/common/wizard/wizard'
import { useAppContext } from '@/context/app'
import { useModal } from '@/components/modal/Modal'
import { SuperAdminInsertMachineTypePopup } from '@/pages/for/superadmin/machinetype/MachineType'
import { SuperAdminInsertUserGroupPopup } from '@/pages/for/superadmin/usergroups/groups'
import { WizardData } from './Model'
import { fetchPDF } from '@/common/fetch'

export interface SimpleUserGroup {
  id: string
  name: string
}

export const MachineWorkingDaysReportWizardStep1 = () => {
  const { services, session, translates } = useAppContext()
  const { wizardData, updateWizardData, nextStep } = useWizard<WizardData>()

  // @ts-ignore: Unreachable code error
  const ReactDatePicker = DatePicker.default ?? DatePicker;
  /* tslint:enable */
  
  function loadPDF() {
    fetchPDF({
      url: `/api/communal/my/reports/machineworkingdays/pdf?from=${wizardData.from.toISOString()}&to=${wizardData.to.toISOString()}&lang=${session?.user.lang}`,
      fileName: "machineworkingdays.pdf",
      services
    })
  }

  if (translates === undefined || wizardData === undefined) {
    return <div className='spinner'></div>
  }

  return <>
    <div>
      <h3>{translates.for('report.machineworkingdays.wizard.title')}</h3>

      <form className="main-form" onSubmit={(e) => {
        e.preventDefault()
        // updateWizardData(wizardData)
        nextStep()
      }}>

        <div className="form-field">
          <label htmlFor="from-date">{translates.for('report.machineworkingdays.wizard.from')}:</label>
          <ReactDatePicker
            id="from-date"
            name="from"
            selected={wizardData.from ? new Date(wizardData.from) : null}
            onChange={(date: Date | string) => {
              date = new Date(date)
              if (wizardData.to < date) {
                return
              }
              updateWizardData({
                ...wizardData,
                from: date || wizardData.from
              })
            }}
            // showTimeSelect={true}
            timeIntervals={15}
            // timeFormat="HH:mm"
            dateFormat="yyyy-MM-dd"
            maxDate={wizardData.to || undefined}
            // placeholderText="Select start date and time"
            className="border rounded p-2"
            portalId="tooltip-wrap"
          />
        </div>

        {/* To Date */}
        <div className="form-field">
          <label htmlFor="to-date">{translates.for('report.machineworkingdays.wizard.to')}:</label>
          <ReactDatePicker
            id="to-date"
            name="to"
            selected={wizardData.to ? new Date(wizardData.to) : null}
            onChange={(date: Date | string) => {
              date = new Date(date)
              if (wizardData.from > date) {
                return
              }
              updateWizardData({
                ...wizardData,
                to: date || wizardData.to
              })
            }}
            // showTimeSelect
            timeIntervals={15}
            // timeFormat="HH:mm"
            dateFormat="yyyy-MM-dd"
            placeholderText=""
            minDate={wizardData.from || undefined}
            className="border rounded p-2"
            portalId="tooltip-wrap"
          />
        </div>
        <div className='right-btns'>
          <button className='btn btn-next' onClick={nextStep}>{translates.for('report.machineworkingdays.wizard.next')}</button>
          {/* <button type="button" className='btn btn-next' onClick={loadHTML}>{translates.for('report.usersranking.wizard.gen_html')}</button> */}
          <button type="button" className='btn btn-next' onClick={loadPDF}>{translates.for('report.usersranking.wizard.gen_pdf')}</button>
        </div>
      </form>
    </div>
  </>
}